module.exports = __webpack_public_path__ + "static/media/04d.99bfaea5.svg";